const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <div className="prose max-w-none">
        <p>Last updated: [Current Date]</p>
        
        <h2>1. Information We Collect</h2>
        <p>We collect information you provide directly to us when using Basket:</p>
        <ul>
          <li>Account information (email, name)</li>
          <li>Study data (baskets, topics, concepts)</li>
          <li>Usage information</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide and improve our services</li>
          <li>Personalize your experience</li>
          <li>Communicate with you</li>
        </ul>

        {/* Add more sections as needed */}
      </div>
    </div>
  );
};

export default PrivacyPolicy; 